module.exports = __webpack_public_path__ + "static/media/20_plantilla_combo_cuadrada_fondo_7.630e5694.png";